import { render, staticRenderFns } from "./Squad.vue?vue&type=template&id=a3d6aaa2&scoped=true&"
import script from "./Squad.vue?vue&type=script&lang=ts&"
export * from "./Squad.vue?vue&type=script&lang=ts&"
import style0 from "./Squad.vue?vue&type=style&index=0&id=a3d6aaa2&prod&lang=css&"
import style1 from "./Squad.vue?vue&type=style&index=1&id=a3d6aaa2&prod&lang=scss&"
import style2 from "./Squad.vue?vue&type=style&index=2&id=a3d6aaa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d6aaa2",
  null
  
)

export default component.exports